<template>
  <Arrival />
</template>

<script>
import  Arrival  from "../nurse/book";
export default {
  name: "doctor-arrival",
  components: {
    Arrival,
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
